import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslation from '../i18n/en.json';
import ruTranslation from '../i18n/ru.json';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources: { [key: string]: { translation: typeof enTranslation } } = {
  en: { translation: enTranslation },
  ru: { translation: ruTranslation },
};

// Detect language from URL BEFORE i18n initializes
let initialLng = 'en';
if (typeof window !== 'undefined') {
  const pathname = window.location.pathname;
  
  // For /admin and /debug pages, check cookie first to preserve language across reloads
  if (pathname.startsWith('/admin') || pathname.startsWith('/debug')) {
    const cookieLang = document.cookie
      .split('; ')
      .find(row => row.startsWith('account-lang='))
      ?.split('=')[1];
    initialLng = cookieLang || 'en';
  } else {
    // For other routes: /ru or /ru/* = Russian, everything else = English
    initialLng = pathname === '/ru' || pathname.startsWith('/ru/') ? 'ru' : 'en';
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLng, // Set initial language from URL
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    detection: {
      // Order of detection methods
      order: ['cookie', 'htmlTag', 'localStorage', 'navigator'],
      // Cookie names to look for language (only for /account page)
      lookupCookie: 'account-lang',
      // Cache user language in cookie
      caches: ['cookie'],
      cookieOptions: { path: '/', maxAge: 60 * 60 * 24 * 30 }, // 30 days
    },
  });

// Add event listener for test language changes
if (typeof window !== 'undefined') {
  console.log('I18n: window is defined, binding language change event');
  const handleLanguageChangeEvent = (evt: any) => {
    console.log(`I18n: Language change event received from tests`);
    if (evt.detail && evt.detail.language) {
      console.log(`I18n: Changing language to: ${evt.detail.language}`);
      i18n.changeLanguage(evt.detail.language);
    }
  };

  // Listen for custom language change events from tests
  document.addEventListener('changeLanguage', handleLanguageChangeEvent);
} else {
  console.log('I18n: window is not defined, not binding language change event');
}

export const t = i18n.t.bind(i18n);

export default i18n;
